var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', {
    staticClass: "text-h5 font-weight-regular pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_vm._v(_vm._s(_vm.funcao))]), _c('v-col', {
    staticClass: "pt-0"
  }, _vm._l(_vm.profissionais, function (profissional) {
    return _c('v-chip', {
      key: profissional.id,
      staticClass: "ma-1"
    }, [_vm._v(_vm._s(profissional.nome))]);
  }), 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }